import React, { FunctionComponent } from 'react';
import {
  QueryLoaderWrapper,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Separator
} from '@companion-professional/components';
import { ClinicInfo } from '@companion-professional/dctypes';
import { Page } from '../../components/Page';
import { UpdatePasswordDialog } from '../../components/UpdatePasswordDialog';
import { useClinicId, useEmail } from '../../state/auth';
import { ProfileSection } from './ProfileSection';
import { ProfileSectionElement } from './ProfileSectionElement';
import { useChangeClinic } from '../../hooks/useChangeClinic';
import { useUserClinics } from '../../hooks/useUserClinics';

export const Profile: FunctionComponent = () => {
  const email = useEmail();
  const currentClinicId = useClinicId();
  const { changeClinic, isPending: changeClinicPending } = useChangeClinic();
  const { userClinics: userClinics, isPending: userClinicsPending, error: userClinicsError } = useUserClinics();

  return (
    <Page title="Profile">
      <div className="flex flex-col space-y-6">
        <ProfileSection sectionTitle="Login &amp; Security">
          <ProfileSectionElement title="Email" description="The email address associated with your account.">
            {email}
          </ProfileSectionElement>
          <Separator />
          <ProfileSectionElement title="Password" description="A unique password for your account login.">
            <UpdatePasswordDialog />
          </ProfileSectionElement>
        </ProfileSection>
        <ProfileSection sectionTitle="Account">
          <ProfileSectionElement
            title="Clinics"
            description={
              'This is a list of clinics you are a part of.  To change the clinic you are currently ' +
              'viewing, select it from the dropdown.'
            }
          >
            <QueryLoaderWrapper
              error={userClinicsError}
              isPending={userClinicsPending || changeClinicPending}
              size="small"
            >
              <Select
                value={currentClinicId}
                onValueChange={(value) => {
                  changeClinic(value).catch((error) => {
                    console.error('Error changing clinic:', error);
                  });
                }}
              >
                <SelectTrigger className="w-[180px]">
                  <SelectValue placeholder="Select a Clinic" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    {(userClinics || [])
                      .sort((u1: ClinicInfo, u2: ClinicInfo) => u1.name.localeCompare(u2.name))
                      .map((clinic: ClinicInfo) => (
                        <SelectItem key={`'select-clinic-${clinic.id}`} value={clinic.id}>
                          {clinic.name}
                        </SelectItem>
                      ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </QueryLoaderWrapper>
          </ProfileSectionElement>
        </ProfileSection>
      </div>
    </Page>
  );
};
